export const forumId: Record<string, number> = {
  'backgammon': 5,
  'сribbage': 4,
  'gin_rummy': 3,
  'red_mahjong': 9,
  'dominos': 6,
  'test': 200,
}